import {List} from "../Common/Elements/List";
import {Friend} from "../../types/farming";
import {FriendEntry} from "./FriendEntry";
import {ListEntryTip} from "../Common/Elements/ListEntryTip";
import {useTranslation} from "react-i18next";


export function FriendList({friends} : {friends : Friend[]}) {
    const {t} = useTranslation()

    const mainListContent = friends.length === 0
        ? <ListEntryTip text={t("inviteFriendsToEarnMoreYep")}/>
        : <List
            createElement={e => <FriendEntry friend={e}/>}
            collection={friends}
            elementHeight={70}
            id={"list-friends"}
        />

    return <div className="friends-view-list">
        {mainListContent}
    </div>
}